import { FC, useState } from "react";
import { useEffect, useRef } from "react";
import { useAppDispatch } from "src/hooks";
import { useAppSelector } from './../../hooks';
import { clientsData, clientsDataInsert, clientsDataPage, dataUpload } from './../../features/clients/clientsActions';
import { ClientsTable } from '../../components/jsx_components/ClientsTable';
import Button from "@mui/material/Button";
import TextField from '@mui/material/TextField';
import "src/styles/working.css";
import CursorPaginationGrid from "src/components/jsx_components/ClientsTablePagination";
import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { TypeSnack } from "src/types/request.type";
//import FileUpload from "react-material-file-upload";

export const ClientsPage: FC = () => {
  const dispatch = useAppDispatch();

  const [snackbar, setSnackbar] = React.useState<TypeSnack>(null);


  //Ошибка неотрисовки!!!!!!
  useEffect(() => {
    dispatch(clientsData());

   //dispatch(clientsDataPage([1, 5]))

  }, [dispatch]);

  const valueRef = useRef<HTMLInputElement | null>(null); //creating a refernce for TextField Component

  const sendValueInsert = () => {

    dispatch(clientsDataInsert(valueRef.current?.value)).then(() => {
      dispatch(clientsDataPage([1, 5]));
      setSnackbar({ children: "Данные добавлены !", title: "success" });
    })

  }

  const handleCloseSnackbar = () => setSnackbar(null);


  return (

    <div style={{ height: "700px", width: "600px", position: 'absolute', left: '210px', top: '10px' }}>


   {/* <ClientsTable>{}</ClientsTable> */}

   {<CursorPaginationGrid></CursorPaginationGrid>}
     
     {/*dataClients?.payload !== null ?
       <ClientsTable>{dataClients?.payload}</ClientsTable> : ""
  */}
      <div>

        <TextField

          inputRef={valueRef}
          sx={{
            color: "white",
            top: 20,
            left: 0,
            height: 40,
            position: "relative",
            "&:hover": {

            },
          }}

          required
          id="outlined-required"
          label="Новый клиент"
          defaultValue=""
        />

        <Button
          sx={{

            color: "white",

            top: 20,
            left: 10,
            height: 59,
            position: "relative",
            width: 195,

            "&:hover": {

            },
          }}
          variant="contained"
          onClick={sendValueInsert}
        >
          Добавить клиента
        </Button>

        <br></br>

        {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
          autoHideDuration={1500}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
      )}




      </div>

    </div>



  );
}